export class DoodleModel {
  public name = '';
  public isDoodleActive = true;
  public isLoading = true;
}
